module.exports = __webpack_public_path__ + "static/media/nkhy.5ada517c.jpeg";